import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../../components/Header";

// css
import styles from "./onboard.module.scss";

import Sidebar from "../../components/Header/sidebar/Sidebar";
import InactiveSessionLogoutPopup from "components/Modals/InactiveSessionLogoutPopup/Index";

const OnboardLayout = () => {
  const [sidebar, setSidebar] = useState();
  const location = useLocation();

  return (
    <>
      <InactiveSessionLogoutPopup />
      <div  >
        <main
          className={`${styles.MainBody} MainBody position-relative`}
        >

          <Outlet />
        </main>
      </div >
    </>
  );
};
export default OnboardLayout;
